import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "calculator" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "title" }, "Калькулятор", -1)
const _hoisted_3 = { class: "calculator-content" }
const _hoisted_4 = { class: "calculator-step step-block step-advance-paynemt" }
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "step-title" }, "Маршрут", -1)
const _hoisted_6 = {
  class: "step-advance-paynemt__route",
  style: {"margin-top":"12px"}
}
const _hoisted_7 = /*#__PURE__*/_createVNode("p", {
  class: "step-title",
  style: {"margin-top":"16px"}
}, "Параметры", -1)
const _hoisted_8 = {
  class: "step-advance-paynemt__parameters",
  style: {"margin-top":"12px"}
}
const _hoisted_9 = { class: "calculator-step step-ordering step-overflow" }
const _hoisted_10 = { class: "calculator-step step-block step-about-cargo" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "step-title" }, "Укажите информацию о грузе", -1)
const _hoisted_12 = {
  class: "about-cargo__first",
  style: {"margin-top":"12px"}
}
const _hoisted_13 = {
  class: "about-cargo__checkboxes",
  style: {"margin-top":"16px"}
}
const _hoisted_14 = {
  class: "about-cargo__insurance",
  style: {"margin-top":"16px"}
}
const _hoisted_15 = {
  class: "about-cargo__additional",
  style: {"margin-top":"16px"}
}
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { class: "additional-title" }, "Дополнительные услуги", -1)
const _hoisted_17 = {
  class: "additional__services",
  style: {"margin-top":"12px"}
}
const _hoisted_18 = { class: "calculator-step step-block step-payment" }
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "step-title" }, "Оплата за доставку", -1)
const _hoisted_20 = {
  class: "step-payment__payer",
  style: {"margin-top":"16px"}
}
const _hoisted_21 = { class: "calculator-step step-block step-confirmation" }
const _hoisted_22 = /*#__PURE__*/_createVNode("p", { class: "step-title" }, "Общая информация", -1)
const _hoisted_23 = {
  class: "calculator-bordered-block",
  style: {"margin-top":"16px","padding":"16px"}
}
const _hoisted_24 = { class: "confirmation-header" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "header-title" }, "Информация об отправителе", -1)
const _hoisted_26 = { class: "confirmation-content" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "confirmation-label" }, "Контактное лицо:", -1)
const _hoisted_28 = { class: "confirmation-value" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Отправитель не указан ")
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "confirmation-label" }, "Контактный телефон:", -1)
const _hoisted_31 = { class: "confirmation-value" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Отправитель не указан ")
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "confirmation-label" }, "Адрес:", -1)
const _hoisted_35 = { class: "confirmation-value" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Отправитель не указан ")
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "confirmation-label" }, "Дата забора и период:", -1)
const _hoisted_38 = { class: "confirmation-value" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Дата забора или период не указаны ")
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "confirmation-label" }, "Комментарий:", -1)
const _hoisted_41 = { class: "confirmation-value" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" --- ")
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Отправитель не указан ")
const _hoisted_44 = /*#__PURE__*/_createVNode("div", { class: "confirmation-label" }, "Доп услуги при заборе:", -1)
const _hoisted_45 = { class: "confirmation-value" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" --- ")
const _hoisted_47 = { class: "confirmation-receiver confirmation-header" }
const _hoisted_48 = /*#__PURE__*/_createVNode("div", { class: "header-title" }, "Информация о получателе", -1)
const _hoisted_49 = { class: "confirmation-content" }
const _hoisted_50 = /*#__PURE__*/_createVNode("div", { class: "confirmation-label" }, "Контактное лицо:", -1)
const _hoisted_51 = { class: "confirmation-value" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" Получатель не указан ")
const _hoisted_53 = /*#__PURE__*/_createVNode("div", { class: "confirmation-label" }, "Контактный телефон:", -1)
const _hoisted_54 = { class: "confirmation-value" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" Получатель не указан ")
const _hoisted_57 = /*#__PURE__*/_createVNode("div", { class: "confirmation-label" }, "Адрес:", -1)
const _hoisted_58 = { class: "confirmation-value" }
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" Получатель не указан ")
const _hoisted_60 = /*#__PURE__*/_createVNode("div", { class: "confirmation-label" }, "Комментарий:", -1)
const _hoisted_61 = { class: "confirmation-value" }
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" --- ")
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" Получатель не указан ")
const _hoisted_64 = /*#__PURE__*/_createVNode("div", { class: "confirmation-label" }, "Доп услуги при доставке:", -1)
const _hoisted_65 = { class: "confirmation-value" }
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" --- ")
const _hoisted_67 = {
  style: {"margin-top":"36px"},
  class: "confirmation-header"
}
const _hoisted_68 = /*#__PURE__*/_createVNode("div", { class: "header-title" }, "Информация о грузе", -1)
const _hoisted_69 = {
  class: "calculator-bordered-block",
  style: {"margin-top":"16px","padding":"16px"}
}
const _hoisted_70 = { class: "confirmation-cargo" }
const _hoisted_71 = { class: "confirmation-block" }
const _hoisted_72 = /*#__PURE__*/_createVNode("div", { class: "confirmation-label" }, "Вес груза", -1)
const _hoisted_73 = { class: "confirmation-value" }
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" --- ")
const _hoisted_75 = { class: "confirmation-block" }
const _hoisted_76 = /*#__PURE__*/_createVNode("div", { class: "confirmation-label" }, "Параметры груза", -1)
const _hoisted_77 = { class: "confirmation-value" }
const _hoisted_78 = { class: "confirmation-block" }
const _hoisted_79 = /*#__PURE__*/_createVNode("div", { class: "confirmation-label" }, "Транспорт", -1)
const _hoisted_80 = { class: "confirmation-value" }
const _hoisted_81 = /*#__PURE__*/_createTextVNode("Авто")
const _hoisted_82 = /*#__PURE__*/_createTextVNode("Авиа")
const _hoisted_83 = /*#__PURE__*/_createTextVNode(" --- ")
const _hoisted_84 = { class: "confirmation-block" }
const _hoisted_85 = /*#__PURE__*/_createVNode("div", { class: "confirmation-label" }, "Доставка", -1)
const _hoisted_86 = { class: "confirmation-value" }
const _hoisted_87 = /*#__PURE__*/_createTextVNode("Авто")
const _hoisted_88 = /*#__PURE__*/_createTextVNode("Авиа")
const _hoisted_89 = /*#__PURE__*/_createTextVNode(" --- ")
const _hoisted_90 = { class: "confirmation-block" }
const _hoisted_91 = /*#__PURE__*/_createVNode("div", { class: "confirmation-label" }, "Количество мест", -1)
const _hoisted_92 = { class: "confirmation-value" }
const _hoisted_93 = { class: "confirmation-block" }
const _hoisted_94 = /*#__PURE__*/_createVNode("div", { class: "confirmation-label" }, "Примечание к отправке", -1)
const _hoisted_95 = { class: "confirmation-value" }
const _hoisted_96 = {
  style: {"margin-top":"36px"},
  class: "confirmation-header"
}
const _hoisted_97 = /*#__PURE__*/_createVNode("div", { class: "header-title" }, "Данные по оплате", -1)
const _hoisted_98 = {
  class: "calculator-bordered-block",
  style: {"margin-top":"16px","padding":"16px"}
}
const _hoisted_99 = {
  class: "confirmation-content",
  style: {"margin-top":"0"}
}
const _hoisted_100 = /*#__PURE__*/_createVNode("div", { class: "confirmation-label" }, "Оплата за доставку:", -1)
const _hoisted_101 = { class: "confirmation-value" }
const _hoisted_102 = /*#__PURE__*/_createTextVNode(" Отправителем ")
const _hoisted_103 = /*#__PURE__*/_createTextVNode(" Получателем ")
const _hoisted_104 = /*#__PURE__*/_createTextVNode(" --- ")
const _hoisted_105 = /*#__PURE__*/_createVNode("div", { class: "confirmation-label" }, "Способ оплаты:", -1)
const _hoisted_106 = { class: "confirmation-value" }
const _hoisted_107 = /*#__PURE__*/_createTextVNode(" Перечислением на счёт ")
const _hoisted_108 = /*#__PURE__*/_createTextVNode(" Наличными ")
const _hoisted_109 = /*#__PURE__*/_createTextVNode(" Платеж на Kaspi.kz ")
const _hoisted_110 = /*#__PURE__*/_createTextVNode(" --- ")
const _hoisted_111 = /*#__PURE__*/_createVNode("div", { class: "confirmation-label" }, "Верифицировать:", -1)
const _hoisted_112 = { class: "confirmation-value" }
const _hoisted_113 = /*#__PURE__*/_createTextVNode("Да")
const _hoisted_114 = /*#__PURE__*/_createTextVNode("Нет")
const _hoisted_115 = /*#__PURE__*/_createVNode("div", { class: "confirmation-label" }, "Возвратные документы:", -1)
const _hoisted_116 = { class: "confirmation-value" }
const _hoisted_117 = /*#__PURE__*/_createTextVNode("Да")
const _hoisted_118 = /*#__PURE__*/_createTextVNode("Нет")
const _hoisted_119 = /*#__PURE__*/_createVNode("div", { class: "confirmation-label" }, "Страховка груза:", -1)
const _hoisted_120 = { class: "confirmation-value" }
const _hoisted_121 = /*#__PURE__*/_createTextVNode("Да")
const _hoisted_122 = /*#__PURE__*/_createTextVNode("Нет")
const _hoisted_123 = /*#__PURE__*/_createVNode("div", { class: "confirmation-label" }, "Наименование груза:", -1)
const _hoisted_124 = { class: "confirmation-value" }
const _hoisted_125 = /*#__PURE__*/_createVNode("div", { class: "confirmation-label" }, "Объявленная стоимость:", -1)
const _hoisted_126 = { class: "confirmation-value" }
const _hoisted_127 = { class: "calculator-window" }
const _hoisted_128 = /*#__PURE__*/_createVNode("p", { class: "window-title" }, "Данные по заказу", -1)
const _hoisted_129 = {
  class: "calculator-bordered-block",
  style: {"margin-top":"12px"}
}
const _hoisted_130 = { class: "window-content" }
const _hoisted_131 = { class: "content-block" }
const _hoisted_132 = /*#__PURE__*/_createVNode("div", { class: "block-hint" }, "Откуда", -1)
const _hoisted_133 = { class: "block-value" }
const _hoisted_134 = /*#__PURE__*/_createTextVNode(" --- ")
const _hoisted_135 = { class: "content-block" }
const _hoisted_136 = /*#__PURE__*/_createVNode("div", { class: "block-hint" }, "Куда", -1)
const _hoisted_137 = { class: "block-value" }
const _hoisted_138 = /*#__PURE__*/_createTextVNode(" --- ")
const _hoisted_139 = { class: "content-block" }
const _hoisted_140 = /*#__PURE__*/_createVNode("div", { class: "block-hint" }, "Параметры", -1)
const _hoisted_141 = { class: "block-value" }
const _hoisted_142 = { class: "content-block" }
const _hoisted_143 = /*#__PURE__*/_createVNode("div", { class: "block-hint" }, "Вес", -1)
const _hoisted_144 = { class: "block-value" }
const _hoisted_145 = { class: "content-block" }
const _hoisted_146 = /*#__PURE__*/_createVNode("div", { class: "block-hint" }, "Количество мест", -1)
const _hoisted_147 = { class: "block-value" }
const _hoisted_148 = {
  key: 0,
  class: "window-calculation"
}
const _hoisted_149 = /*#__PURE__*/_createVNode("p", { class: "window-title" }, "Предварительный расчет", -1)
const _hoisted_150 = { class: "calculation-content" }
const _hoisted_151 = /*#__PURE__*/_createVNode("p", { class: "item-shipment-type-label" }, "Тип доставки", -1)
const _hoisted_152 = /*#__PURE__*/_createVNode("div", { class: "item-shipment-type" }, [
  /*#__PURE__*/_createVNode("img", {
    alt: "Авто",
    src: "/shipment-auto.png"
  }),
  /*#__PURE__*/_createVNode("div", { class: "item-shipment-type-value" }, "АВТО")
], -1)
const _hoisted_153 = {
  key: 0,
  class: "item-loader"
}
const _hoisted_154 = { class: "item-price" }
const _hoisted_155 = { class: "item-time" }
const _hoisted_156 = {
  key: 0,
  class: "time-value"
}
const _hoisted_157 = {
  key: 0,
  class: "item-action"
}
const _hoisted_158 = /*#__PURE__*/_createTextVNode(" Выбрать ")
const _hoisted_159 = /*#__PURE__*/_createVNode("p", { class: "item-shipment-type-label" }, "Тип доставки", -1)
const _hoisted_160 = /*#__PURE__*/_createVNode("div", { class: "item-shipment-type" }, [
  /*#__PURE__*/_createVNode("img", {
    alt: "Авто",
    src: "/shipment-avia.png"
  }),
  /*#__PURE__*/_createVNode("div", { class: "item-shipment-type-value" }, "АВИА")
], -1)
const _hoisted_161 = {
  key: 0,
  class: "item-loader"
}
const _hoisted_162 = { class: "item-price" }
const _hoisted_163 = { class: "item-time" }
const _hoisted_164 = {
  key: 0,
  class: "time-value"
}
const _hoisted_165 = {
  key: 0,
  class: "item-action"
}
const _hoisted_166 = /*#__PURE__*/_createTextVNode(" Выбрать ")
const _hoisted_167 = { class: "window-footer" }
const _hoisted_168 = /*#__PURE__*/_createTextVNode(" Отмена ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_template_form = _resolveComponent("template-form")!
  const _component_progress_steps = _resolveComponent("progress-steps")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_s_input = _resolveComponent("s-input")!
  const _component_template_panel = _resolveComponent("template-panel")!
  const _component_additional_services_on_take = _resolveComponent("additional-services-on-take")!
  const _component_additional_services_on_delivery = _resolveComponent("additional-services-on-delivery")!
  const _component_date_calendar = _resolveComponent("date-calendar")!
  const _component_s_checkbox = _resolveComponent("s-checkbox")!
  const _component_file_loader = _resolveComponent("file-loader")!
  const _component_payment_method = _resolveComponent("payment-method")!
  const _component_payment_type = _resolveComponent("payment-type")!
  const _component_s_loader = _resolveComponent("s-loader")!
  const _component_icon_checkmark = _resolveComponent("icon-checkmark")!
  const _component_new_button = _resolveComponent("new-button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.template_form.is_opened)
      ? (_openBlock(), _createBlock(_component_template_form, {
          key: 0,
          loading: _ctx.template_form.is_loading,
          "is-update": _ctx.template_form.is_update,
          "is-receiver-template": _ctx.template_form.is_receiver_template,
          "initial-value": _ctx.template_form.initial_value,
          "exact-city-id": _ctx.templateFormExactCityId,
          onCreateSender: _ctx.onCreateSender,
          onUpdateSender: _ctx.onUpdateSender,
          onCreateReceiver: _ctx.onCreateReceiver,
          onUpdateReceiver: _ctx.onUpdateReceiver,
          onClose: _ctx.closeTemplateForm
        }, null, 8, ["loading", "is-update", "is-receiver-template", "initial-value", "exact-city-id", "onCreateSender", "onUpdateSender", "onCreateReceiver", "onUpdateReceiver", "onClose"]))
      : _createCommentVNode("", true),
    _hoisted_2,
    _createVNode(_component_progress_steps, {
      "active-step-id": _ctx.state.current_step,
      "onUpdate:active-step-id": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.current_step = $event)),
      steps: _ctx.PROGRESS_STEPS,
      "completed-steps-ids": _ctx.state.completed_steps,
      "available-steps-ids": _ctx.state.available_steps
    }, null, 8, ["active-step-id", "steps", "completed-steps-ids", "available-steps-ids"]),
    _createVNode("div", _hoisted_3, [
      _withDirectives(_createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_multiselect, {
            modelValue: _ctx.advance_paynemt_state.city_from,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.advance_paynemt_state.city_from = $event)),
            class: { invalid: _ctx.advance_paynemt$.city_from.$error },
            options: _ctx.data_state.from_cities.options,
            object: true,
            disabled: _ctx.state.is_order_creating,
            loading: _ctx.data_state.from_cities.is_loading,
            label: "name",
            trackBy: "name",
            placeholder: "Откуда",
            searchable: "",
            noResultsText: "Ничего не найдено",
            noOptionsText: "Список пуст",
            onChange: _ctx.loadToCities
          }, null, 8, ["modelValue", "class", "options", "disabled", "loading", "onChange"]),
          _createVNode(_component_multiselect, {
            modelValue: _ctx.advance_paynemt_state.city_to,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.advance_paynemt_state.city_to = $event)),
            class: { invalid: _ctx.advance_paynemt$.city_to.$error },
            options: _ctx.data_state.to_cities.options,
            object: true,
            disabled: _ctx.state.is_order_creating,
            loading: _ctx.data_state.to_cities.is_loading,
            label: "name",
            trackBy: "name",
            placeholder: "Куда",
            searchable: "",
            noResultsText: "Ничего не найдено",
            noOptionsText: "Список пуст",
            onChange: _ctx.onToCitySelect
          }, null, 8, ["modelValue", "class", "options", "disabled", "loading", "onChange"])
        ]),
        _hoisted_7,
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_s_input, {
            value: _ctx.advance_paynemt_state.length,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.advance_paynemt_state.length = $event)),
            "is-invalid": _ctx.advance_paynemt$.length.$error,
            disabled: _ctx.state.is_order_creating,
            placeholder: "Макс. длина (см)",
            onChange: _ctx.recalculateTariffs
          }, null, 8, ["value", "is-invalid", "disabled", "onChange"]),
          _createVNode(_component_s_input, {
            value: _ctx.advance_paynemt_state.places,
            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_ctx.advance_paynemt_state.places = $event)),
            "is-invalid": _ctx.advance_paynemt$.places.$error,
            disabled: _ctx.state.is_order_creating,
            placeholder: "Количество мест",
            onChange: _ctx.recalculateTariffs
          }, null, 8, ["value", "is-invalid", "disabled", "onChange"]),
          _createVNode(_component_s_input, {
            value: _ctx.advance_paynemt_state.width,
            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.advance_paynemt_state.width = $event)),
            "is-invalid": _ctx.advance_paynemt$.width.$error,
            disabled: _ctx.state.is_order_creating,
            placeholder: "Макс. ширина (см)",
            onChange: _ctx.recalculateTariffs
          }, null, 8, ["value", "is-invalid", "disabled", "onChange"]),
          _createVNode(_component_s_input, {
            value: _ctx.advance_paynemt_state.weight,
            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (_ctx.advance_paynemt_state.weight = $event)),
            "is-invalid": _ctx.advance_paynemt$.weight.$error,
            disabled: _ctx.state.is_order_creating,
            placeholder: "Вес груза (кг)",
            onChange: _ctx.recalculateTariffs
          }, null, 8, ["value", "is-invalid", "disabled", "onChange"]),
          _createVNode(_component_s_input, {
            value: _ctx.advance_paynemt_state.height,
            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_ctx.advance_paynemt_state.height = $event)),
            "is-invalid": _ctx.advance_paynemt$.height.$error,
            disabled: _ctx.state.is_order_creating,
            placeholder: "Макс. высота (см)",
            onChange: _ctx.recalculateTariffs
          }, null, 8, ["value", "is-invalid", "disabled", "onChange"])
        ])
      ], 512), [
        [_vShow, _ctx.state.current_step === _ctx.PROGRESS_STEPS[0].id]
      ]),
      _withDirectives(_createVNode("div", _hoisted_9, [
        _createVNode(_component_template_panel, {
          title: "Выберите отправителя",
          "create-text": "Новый отправитель",
          "current-page": _ctx.data_state.senders.current_page,
          "total-pages": _ctx.data_state.senders.total_pages,
          loading: _ctx.data_state.senders.is_loading,
          disabled: _ctx.state.is_order_creating,
          templates: _ctx.data_state.senders.list,
          selectedTemplatesIds: _ctx.selectedSenders,
          onCreate: _ctx.startCreateSender,
          onLoadMore: _ctx.loadMoreSenders,
          onSearch: _ctx.searchSender,
          onSelectTemplate: _ctx.onSelectSender,
          onDeleteTemplate: _ctx.onDeleteSender,
          onUpdateTemplate: _ctx.startUpdateSender
        }, null, 8, ["current-page", "total-pages", "loading", "disabled", "templates", "selectedTemplatesIds", "onCreate", "onLoadMore", "onSearch", "onSelectTemplate", "onDeleteTemplate", "onUpdateTemplate"]),
        _createVNode(_component_additional_services_on_take, {
          setted: _ctx.ordering_state.is_additional_services_on_take_setted,
          disabled: _ctx.state.is_order_creating,
          onSubmit: _ctx.setAdditionalServicesOnTake,
          onReset: _ctx.resetAdditionalServicesOnTake
        }, null, 8, ["setted", "disabled", "onSubmit", "onReset"]),
        _createVNode(_component_template_panel, {
          class: "ReceiversTemplatePanel",
          title: "Выберите получателя",
          "create-text": "Новый получатель",
          "is-receiver-templates": "",
          "current-page": _ctx.data_state.receivers.current_page,
          "total-pages": _ctx.data_state.receivers.total_pages,
          loading: _ctx.data_state.receivers.is_loading,
          disabled: _ctx.state.is_order_creating,
          templates: _ctx.data_state.receivers.list,
          selectedTemplatesIds: _ctx.selectedReceivers,
          onCreate: _ctx.startCreateReceiver,
          onLoadMore: _ctx.loadMoreReceivers,
          onSearch: _ctx.searchReceiver,
          onSelectTemplate: _ctx.onSelectReceiver,
          onDeleteTemplate: _ctx.onDeleteReceiver,
          onUpdateTemplate: _ctx.startUpdateReceiver
        }, null, 8, ["current-page", "total-pages", "loading", "disabled", "templates", "selectedTemplatesIds", "onCreate", "onLoadMore", "onSearch", "onSelectTemplate", "onDeleteTemplate", "onUpdateTemplate"]),
        _createVNode(_component_additional_services_on_delivery, {
          setted: _ctx.ordering_state.is_additional_services_on_delivery_setted,
          disabled: _ctx.state.is_order_creating,
          onSubmit: _ctx.setAdditionalServicesOnDelivery,
          onReset: _ctx.resetAdditionalServicesOnDelivery
        }, null, 8, ["setted", "disabled", "onSubmit", "onReset"]),
        _createVNode(_component_date_calendar, {
          setted: _ctx.ordering_state.is_date_setted,
          disabled: _ctx.state.is_order_creating,
          onSubmit: _ctx.setTakeDate,
          onReset: _ctx.resetTakeDate
        }, null, 8, ["setted", "disabled", "onSubmit", "onReset"])
      ], 512), [
        [_vShow, _ctx.state.current_step === _ctx.PROGRESS_STEPS[1].id]
      ]),
      _withDirectives(_createVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode("div", _hoisted_12, [
          _createVNode(_component_s_input, {
            value: _ctx.about_cargo_state.product_name,
            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (_ctx.about_cargo_state.product_name = $event)),
            placeholder: "Наименование товара",
            "is-invalid": _ctx.about_cargo$.product_name.$error,
            disabled: _ctx.state.is_order_creating
          }, null, 8, ["value", "is-invalid", "disabled"]),
          _createVNode(_component_s_input, {
            value: _ctx.about_cargo_state.customer_invoice_number,
            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => (_ctx.about_cargo_state.customer_invoice_number = $event)),
            placeholder: _ctx.customInvoiceNumberPlaceholder,
            "is-invalid": _ctx.about_cargo$.customer_invoice_number.$error,
            disabled: _ctx.state.is_order_creating
          }, null, 8, ["value", "placeholder", "is-invalid", "disabled"]),
          _createVNode(_component_s_input, {
            value: _ctx.about_cargo_state.cod_payment,
            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => (_ctx.about_cargo_state.cod_payment = $event)),
            placeholder: "Наложенный платеж",
            "is-invalid": _ctx.about_cargo$.cod_payment.$error,
            disabled: _ctx.state.is_order_creating
          }, null, 8, ["value", "is-invalid", "disabled"]),
          _createVNode(_component_s_input, {
            value: _ctx.about_cargo_state.annotation,
            "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => (_ctx.about_cargo_state.annotation = $event)),
            placeholder: "Примечание к отправке",
            disabled: _ctx.state.is_order_creating
          }, null, 8, ["value", "disabled"])
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode(_component_s_checkbox, {
            theme: "primary",
            label: "Застраховать груз",
            value: _ctx.about_cargo_state.is_insurance,
            "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => (_ctx.about_cargo_state.is_insurance = $event)),
            disabled: _ctx.state.is_order_creating,
            onChange: _ctx.onInsuranceToggle
          }, null, 8, ["value", "disabled", "onChange"]),
          _createVNode(_component_s_checkbox, {
            theme: "primary",
            label: "Верифицировать",
            value: _ctx.about_cargo_state.verify,
            "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => (_ctx.about_cargo_state.verify = $event)),
            disabled: _ctx.state.is_order_creating
          }, null, 8, ["value", "disabled"]),
          _createVNode(_component_s_checkbox, {
            theme: "primary",
            label: "Возвратные документы",
            value: _ctx.about_cargo_state.is_return_documents,
            "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => (_ctx.about_cargo_state.is_return_documents = $event)),
            disabled: _ctx.state.is_order_creating
          }, null, 8, ["value", "disabled"]),
          _createVNode(_component_s_checkbox, {
            theme: "primary",
            label: "Температурный режим",
            value: _ctx.about_cargo_state.is_temperature_regime,
            "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => (_ctx.about_cargo_state.is_temperature_regime = $event)),
            disabled: _ctx.state.is_order_creating,
            onChange: _ctx.onTemperatureToggle
          }, null, 8, ["value", "disabled", "onChange"]),
          _createVNode(_component_s_checkbox, {
            theme: "primary",
            label: "Опасный груз",
            value: _ctx.about_cargo_state.is_dangerous,
            "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => (_ctx.about_cargo_state.is_dangerous = $event)),
            disabled: _ctx.state.is_order_creating,
            onChange: _ctx.onDangerousToggle
          }, null, 8, ["value", "disabled", "onChange"])
        ]),
        _createVNode("div", _hoisted_14, [
          _withDirectives(_createVNode(_component_s_input, {
            placeholder: "Наименование груза",
            value: _ctx.about_cargo_state.insurance_cargo_name,
            "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => (_ctx.about_cargo_state.insurance_cargo_name = $event)),
            "is-invalid": _ctx.about_cargo$.insurance_cargo_name.$error,
            disabled: _ctx.state.is_order_creating
          }, null, 8, ["value", "is-invalid", "disabled"]), [
            [_vShow, _ctx.about_cargo_state.is_insurance]
          ]),
          _withDirectives(_createVNode(_component_s_input, {
            value: _ctx.about_cargo_state.declared_price,
            "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => (_ctx.about_cargo_state.declared_price = $event)),
            placeholder: "Объявленная стоимость",
            "is-invalid": _ctx.about_cargo$.declared_price.$error,
            disabled: _ctx.state.is_order_creating
          }, null, 8, ["value", "is-invalid", "disabled"]), [
            [_vShow, _ctx.about_cargo_state.is_insurance]
          ]),
          _withDirectives(_createVNode(_component_s_input, {
            value: _ctx.about_cargo_state.temperature_regime,
            "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => (_ctx.about_cargo_state.temperature_regime = $event)),
            placeholder: "Температурный режим",
            "is-invalid": _ctx.about_cargo$.temperature_regime.$error,
            disabled: _ctx.state.is_order_creating
          }, null, 8, ["value", "is-invalid", "disabled"]), [
            [_vShow, _ctx.about_cargo_state.is_temperature_regime]
          ]),
          _withDirectives(_createVNode(_component_file_loader, {
            value: _ctx.about_cargo_state.invoice_files,
            "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => (_ctx.about_cargo_state.invoice_files = $event)),
            placeholder: "Загрузите файл накладной",
            "loaded-files-placeholder": "Файл накладной",
            "is-invalid": _ctx.about_cargo$.invoice_files.$error,
            "is-multi-select": "",
            "is-small": "",
            disabled: _ctx.state.is_order_creating
          }, null, 8, ["value", "is-invalid", "disabled"]), [
            [_vShow, _ctx.about_cargo_state.is_dangerous]
          ]),
          _withDirectives(_createVNode(_component_file_loader, {
            value: _ctx.about_cargo_state.certificate_of_safety_files,
            "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => (_ctx.about_cargo_state.certificate_of_safety_files = $event)),
            placeholder: "Загрузите сертификат безопасности",
            "loaded-files-placeholder": "Сертификат безопасности",
            "is-invalid": _ctx.about_cargo$.certificate_of_safety_files.$error,
            "is-multi-select": "",
            "is-small": "",
            disabled: _ctx.state.is_order_creating
          }, null, 8, ["value", "is-invalid", "disabled"]), [
            [_vShow, _ctx.about_cargo_state.is_dangerous]
          ])
        ]),
        _createVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode("div", _hoisted_17, [
            _createVNode(_component_s_checkbox, {
              theme: "primary",
              label: "Обрешетка",
              value: _ctx.about_cargo_state.hasGrid,
              "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => (_ctx.about_cargo_state.hasGrid = $event)),
              disabled: _ctx.state.is_order_creating,
              onChange: _ctx.onGridChange
            }, null, 8, ["value", "disabled", "onChange"]),
            _createVNode(_component_s_checkbox, {
              theme: "primary",
              label: "Паллета",
              value: _ctx.about_cargo_state.hasPallet,
              "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => (_ctx.about_cargo_state.hasPallet = $event)),
              disabled: _ctx.state.is_order_creating,
              onChange: _ctx.onPalletChange
            }, null, 8, ["value", "disabled", "onChange"]),
            _createVNode(_component_s_checkbox, {
              theme: "primary",
              label: "Мягкая упаковка",
              value: _ctx.about_cargo_state.hasSoftPackage,
              "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => (_ctx.about_cargo_state.hasSoftPackage = $event)),
              disabled: _ctx.state.is_order_creating,
              onChange: _ctx.onSoftPackageChange
            }, null, 8, ["value", "disabled", "onChange"])
          ])
        ])
      ], 512), [
        [_vShow, _ctx.state.current_step === _ctx.PROGRESS_STEPS[2].id]
      ]),
      _withDirectives(_createVNode("div", _hoisted_18, [
        _hoisted_19,
        _createVNode(_component_payment_method, {
          style: {"margin-top":"16px"},
          value: _ctx.payment_state.payment_method,
          "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => (_ctx.payment_state.payment_method = $event)),
          disabled: _ctx.state.is_order_creating,
          "payment-type": _ctx.payment_state.payment_type,
          "receiver-city-type": _ctx.ordering_state.receiver ? _ctx.ordering_state.receiver.city_type : null,
          "is-cash-enabled-by-setting": _ctx.isCashEnabled,
          "is-kaspi-enabled-by-setting": _ctx.isKaspiEnabled,
          onChange: _ctx.onPaymentMethodChange
        }, null, 8, ["value", "disabled", "payment-type", "receiver-city-type", "is-cash-enabled-by-setting", "is-kaspi-enabled-by-setting", "onChange"]),
        _createVNode(_component_payment_type, {
          style: {"margin-top":"16px"},
          "payers-length": _ctx.data_state.payers.list.length,
          "disabled-options-values": _ctx.disabledPaymentTypeOptionsValues,
          disabled: _ctx.state.is_order_creating,
          "sender-company-name": _ctx.senderCompanyName,
          value: _ctx.payment_state.payment_type,
          "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => (_ctx.payment_state.payment_type = $event)),
          onChange: _ctx.onPaymentTypeChange
        }, null, 8, ["payers-length", "disabled-options-values", "disabled", "sender-company-name", "value", "onChange"]),
        _withDirectives(_createVNode("div", _hoisted_20, [
          _createVNode(_component_multiselect, {
            modelValue: _ctx.payment_state.payer,
            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.payment_state.payer = $event)),
            class: { invalid: _ctx.payment$.payer.$error },
            options: _ctx.data_state.payers.list,
            disabled: _ctx.state.is_order_creating,
            object: true,
            loading: _ctx.data_state.payers.is_loading,
            label: "name",
            trackBy: "name",
            placeholder: "Плательщик",
            searchable: "",
            noResultsText: "Ничего не найдено",
            noOptionsText: "Список пуст"
          }, null, 8, ["modelValue", "class", "options", "disabled", "loading"])
        ], 512), [
          [_vShow, 
                        (_ctx.payment_state.payment_type === 2 || _ctx.payment_state.payment_type === 3) &&
                        _ctx.payment_state.payment_method === 3
                    ]
        ])
      ], 512), [
        [_vShow, _ctx.state.current_step === _ctx.PROGRESS_STEPS[3].id]
      ]),
      _withDirectives(_createVNode("div", _hoisted_21, [
        _hoisted_22,
        _createVNode("div", _hoisted_23, [
          _createVNode("div", _hoisted_24, [
            _hoisted_25,
            (!_ctx.state.is_order_creating)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: "header-edit",
                  onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.changeActiveStep(2)))
                }, " Изменить "))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_26, [
            _hoisted_27,
            _createVNode("div", _hoisted_28, [
              (_ctx.ordering_state.sender)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.ordering_state.sender.full_name), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_29
                  ], 64))
            ]),
            _hoisted_30,
            _createVNode("div", _hoisted_31, [
              (_ctx.ordering_state.sender)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createVNode("p", null, _toDisplayString(_ctx.ordering_state.sender.phone), 1),
                    (_ctx.ordering_state.sender.additional_phone)
                      ? (_openBlock(), _createBlock("p", _hoisted_32, _toDisplayString(_ctx.ordering_state.sender.additional_phone), 1))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_33
                  ], 64))
            ]),
            _hoisted_34,
            _createVNode("div", _hoisted_35, [
              (_ctx.ordering_state.sender)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.ordering_state.sender.full_address), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_36
                  ], 64))
            ]),
            _hoisted_37,
            _createVNode("div", _hoisted_38, [
              (_ctx.formattedTakeDate && _ctx.ordering_state.take_period)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.formattedTakeDate) + " " + _toDisplayString(_ctx.ordering_state.take_period.name), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_39
                  ], 64))
            ]),
            _hoisted_40,
            _createVNode("div", _hoisted_41, [
              (_ctx.ordering_state.sender)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    (_ctx.ordering_state.sender.comment)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.ordering_state.sender.comment), 1)
                        ], 64))
                      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                          _hoisted_42
                        ], 64))
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_43
                  ], 64))
            ]),
            _hoisted_44,
            _createVNode("div", _hoisted_45, [
              (_ctx.ordering_state.additionalServicesTake.length)
                ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.ordering_state.additionalServicesTake, (service, i) => {
                    return (_openBlock(), _createBlock("span", {
                      key: service.id
                    }, [
                      (i === 0)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.getServiceName(service.code)), 1)
                          ], 64))
                        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(" , " + _toDisplayString(_ctx.getServiceName(service.code)), 1)
                          ], 64))
                    ]))
                  }), 128))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_46
                  ], 64))
            ])
          ]),
          _createVNode("div", _hoisted_47, [
            _hoisted_48,
            (!_ctx.state.is_order_creating)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: "header-edit",
                  onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.changeActiveStep(2)))
                }, " Изменить "))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_49, [
            _hoisted_50,
            _createVNode("div", _hoisted_51, [
              (_ctx.ordering_state.receiver)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.ordering_state.receiver.full_name), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_52
                  ], 64))
            ]),
            _hoisted_53,
            _createVNode("div", _hoisted_54, [
              (_ctx.ordering_state.receiver)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createVNode("p", null, _toDisplayString(_ctx.ordering_state.receiver.phone), 1),
                    (_ctx.ordering_state.receiver.additional_phone)
                      ? (_openBlock(), _createBlock("p", _hoisted_55, _toDisplayString(_ctx.ordering_state.receiver.additional_phone), 1))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_56
                  ], 64))
            ]),
            _hoisted_57,
            _createVNode("div", _hoisted_58, [
              (_ctx.ordering_state.receiver)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.ordering_state.receiver.full_address), 1)
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_59
                  ], 64))
            ]),
            _hoisted_60,
            _createVNode("div", _hoisted_61, [
              (_ctx.ordering_state.receiver)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    (_ctx.ordering_state.receiver.comment)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.ordering_state.receiver.comment), 1)
                        ], 64))
                      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                          _hoisted_62
                        ], 64))
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_63
                  ], 64))
            ]),
            _hoisted_64,
            _createVNode("div", _hoisted_65, [
              (_ctx.ordering_state.additionalServicesDelivery.length)
                ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.ordering_state.additionalServicesDelivery, (service, i) => {
                    return (_openBlock(), _createBlock("span", {
                      key: service.id
                    }, [
                      (i === 0)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.getServiceName(service.code)), 1)
                          ], 64))
                        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(" , " + _toDisplayString(_ctx.getServiceName(service.code)), 1)
                          ], 64))
                    ]))
                  }), 128))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_66
                  ], 64))
            ])
          ])
        ]),
        _createVNode("div", _hoisted_67, [
          _hoisted_68,
          (!_ctx.state.is_order_creating)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: "header-edit",
                onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.changeActiveStep(3)))
              }, " Изменить "))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_69, [
          _createVNode("div", _hoisted_70, [
            _createVNode("div", _hoisted_71, [
              _hoisted_72,
              _createVNode("div", _hoisted_73, [
                (_ctx.weight)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.weight), 1)
                    ], 64))
                  : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_74
                    ], 64))
              ])
            ]),
            _createVNode("div", _hoisted_75, [
              _hoisted_76,
              _createVNode("div", _hoisted_77, _toDisplayString(_ctx.parameters), 1)
            ]),
            _createVNode("div", _hoisted_78, [
              _hoisted_79,
              _createVNode("div", _hoisted_80, [
                (_ctx.billing_state.selected_tariff)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      (_ctx.billing_state.selected_tariff.shipmentTypeId === 1)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                            _hoisted_81
                          ], 64))
                        : (
                                            _ctx.billing_state.selected_tariff.shipmentTypeId === 2
                                        )
                          ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                              _hoisted_82
                            ], 64))
                          : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_83
                    ], 64))
              ])
            ]),
            _createVNode("div", _hoisted_84, [
              _hoisted_85,
              _createVNode("div", _hoisted_86, [
                (_ctx.billing_state.selected_tariff)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      (_ctx.billing_state.selected_tariff.shipmentTypeId === 1)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                            _hoisted_87
                          ], 64))
                        : (
                                            _ctx.billing_state.selected_tariff.shipmentTypeId === 2
                                        )
                          ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                              _hoisted_88
                            ], 64))
                          : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_89
                    ], 64))
              ])
            ]),
            _createVNode("div", _hoisted_90, [
              _hoisted_91,
              _createVNode("div", _hoisted_92, _toDisplayString(_ctx.advance_paynemt_state.places || '---'), 1)
            ]),
            _createVNode("div", _hoisted_93, [
              _hoisted_94,
              _createVNode("div", _hoisted_95, _toDisplayString(_ctx.about_cargo_state.annotation || '---'), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_96, [
          _hoisted_97,
          (!_ctx.state.is_order_creating)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: "header-edit",
                onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.changeActiveStep(4)))
              }, " Изменить "))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_98, [
          _createVNode("div", _hoisted_99, [
            _hoisted_100,
            _createVNode("div", _hoisted_101, [
              (_ctx.payment_state.payment_type === 1)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _hoisted_102
                  ], 64))
                : (_ctx.payment_state.payment_type === 2)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_103
                    ], 64))
                  : (_ctx.payment_state.payment_type === 3 && _ctx.payment_state.payer)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(" Третьим лицом (" + _toDisplayString(_ctx.payment_state.payer.name) + ") ", 1)
                      ], 64))
                    : (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                        _hoisted_104
                      ], 64))
            ]),
            _hoisted_105,
            _createVNode("div", _hoisted_106, [
              (_ctx.payment_state.payment_method === 3)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _hoisted_107
                  ], 64))
                : (_ctx.payment_state.payment_method === 2)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_108
                    ], 64))
                  : (_ctx.payment_state.payment_method === 4)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                        _hoisted_109
                      ], 64))
                    : (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                        _hoisted_110
                      ], 64))
            ]),
            _hoisted_111,
            _createVNode("div", _hoisted_112, [
              (_ctx.about_cargo_state.verify)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _hoisted_113
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_114
                  ], 64))
            ]),
            _hoisted_115,
            _createVNode("div", _hoisted_116, [
              (_ctx.about_cargo_state.is_return_documents)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _hoisted_117
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_118
                  ], 64))
            ]),
            _hoisted_119,
            _createVNode("div", _hoisted_120, [
              (_ctx.about_cargo_state.is_insurance)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _hoisted_121
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_122
                  ], 64))
            ]),
            _hoisted_123,
            _createVNode("div", _hoisted_124, _toDisplayString(_ctx.about_cargo_state.insurance_cargo_name || '---'), 1),
            _hoisted_125,
            _createVNode("div", _hoisted_126, _toDisplayString(_ctx.about_cargo_state.declared_price || '---'), 1)
          ])
        ])
      ], 512), [
        [_vShow, _ctx.state.current_step === _ctx.PROGRESS_STEPS[4].id]
      ]),
      _createVNode("div", _hoisted_127, [
        _hoisted_128,
        _createVNode("div", _hoisted_129, [
          _createVNode("div", _hoisted_130, [
            _createVNode("div", _hoisted_131, [
              _hoisted_132,
              _createVNode("div", _hoisted_133, [
                (_ctx.advance_paynemt_state.city_from)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.advance_paynemt_state.city_from.name), 1)
                    ], 64))
                  : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_134
                    ], 64))
              ])
            ]),
            _createVNode("div", _hoisted_135, [
              _hoisted_136,
              _createVNode("div", _hoisted_137, [
                (_ctx.advance_paynemt_state.city_to)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.advance_paynemt_state.city_to.name), 1)
                    ], 64))
                  : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_138
                    ], 64))
              ])
            ]),
            _createVNode("div", _hoisted_139, [
              _hoisted_140,
              _createVNode("div", _hoisted_141, _toDisplayString(_ctx.parameters), 1)
            ]),
            _createVNode("div", _hoisted_142, [
              _hoisted_143,
              _createVNode("div", _hoisted_144, _toDisplayString(_ctx.weight || '---'), 1)
            ]),
            _createVNode("div", _hoisted_145, [
              _hoisted_146,
              _createVNode("div", _hoisted_147, _toDisplayString(_ctx.advance_paynemt_state.places || '---'), 1)
            ])
          ])
        ]),
        (_ctx.billing_state.is_calculating)
          ? (_openBlock(), _createBlock("div", _hoisted_148, [
              _hoisted_149,
              _createVNode("div", _hoisted_150, [
                _createVNode("div", {
                  class: ["calculation-item", { 'item--selected': _ctx.isItemSelected('auto') }]
                }, [
                  _hoisted_151,
                  _hoisted_152,
                  (_ctx.billing_state.auto.is_loading)
                    ? (_openBlock(), _createBlock("div", _hoisted_153, [
                        _createVNode(_component_s_loader)
                      ]))
                    : (Boolean(_ctx.billing_state.auto.tariff))
                      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                          _createVNode("div", _hoisted_154, " от " + _toDisplayString(_ctx.billing_state.auto.tariff.result.toFixed(2)) + " тг ", 1),
                          _createVNode("div", _hoisted_155, [
                            _createVNode(_component_icon_checkmark, { class: "time-icon" }),
                            (_ctx.data_state.direction.data)
                              ? (_openBlock(), _createBlock("div", _hoisted_156, " До " + _toDisplayString(_ctx.data_state.direction.data.standart_delivery_time) + " дней ", 1))
                              : _createCommentVNode("", true)
                          ]),
                          (!_ctx.isItemSelected('auto') && !_ctx.state.is_order_creating)
                            ? (_openBlock(), _createBlock("div", _hoisted_157, [
                                _createVNode(_component_new_button, {
                                  style: {"padding":"8px 16px"},
                                  class: "button--outline button--primary button--small",
                                  onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.selectTariff('auto')))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_158
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                ], 2),
                _createVNode("div", {
                  class: ["calculation-item", { 'item--selected': _ctx.isItemSelected('avia') }]
                }, [
                  _hoisted_159,
                  _hoisted_160,
                  (_ctx.billing_state.avia.is_loading)
                    ? (_openBlock(), _createBlock("div", _hoisted_161, [
                        _createVNode(_component_s_loader)
                      ]))
                    : (Boolean(_ctx.billing_state.avia.tariff))
                      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                          _createVNode("div", _hoisted_162, " от " + _toDisplayString(_ctx.billing_state.avia.tariff.result.toFixed(2)) + " тг ", 1),
                          _createVNode("div", _hoisted_163, [
                            _createVNode(_component_icon_checkmark, { class: "time-icon" }),
                            (_ctx.data_state.direction.data)
                              ? (_openBlock(), _createBlock("div", _hoisted_164, " До " + _toDisplayString(_ctx.data_state.direction.data.express_delivery_time) + " дней ", 1))
                              : _createCommentVNode("", true)
                          ]),
                          (!_ctx.isItemSelected('avia') && !_ctx.state.is_order_creating)
                            ? (_openBlock(), _createBlock("div", _hoisted_165, [
                                _createVNode(_component_new_button, {
                                  style: {"padding":"8px 16px"},
                                  class: "button--outline button--primary button--small",
                                  onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.selectTariff('avia')))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_166
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                ], 2)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_167, [
          _createVNode(_component_new_button, {
            class: "button--outline button--primary button--small",
            disabled: _ctx.state.is_order_creating,
            onClick: _ctx.onCancel
          }, {
            default: _withCtx(() => [
              _hoisted_168
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_new_button, {
            class: "button--primary button--small",
            loading: _ctx.state.is_order_creating,
            onClick: _ctx.onContinue
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.continueButtonText), 1)
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ])
      ])
    ])
  ]))
}